import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { AdminUser } from '../api/auth.api';

// Helper function to check if user is authenticated
const getInitialState = () => {
  // Check localStorage directly for persisted token
  const token = localStorage.getItem('admin_token');
  const userStr = localStorage.getItem('admin_user');

  if (token && userStr) {
    try {
      const user = JSON.parse(userStr) as AdminUser;
      return {
        token,
        user,
        isAuthenticated: true,
      };
    } catch {
      // Invalid JSON, clear storage
      localStorage.removeItem('admin_token');
      localStorage.removeItem('admin_user');
    }
  }

  return {
    token: null,
    user: null,
    isAuthenticated: false,
  };
};

interface AuthState {
  token: string | null;
  user: AdminUser | null;
  isAuthenticated: boolean;
  setAuth: (token: string, user: AdminUser) => void;
  clearAuth: () => void;
  setUser: (user: AdminUser) => void;
}

const initialState = getInitialState();

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: initialState.token,
      user: initialState.user,
      isAuthenticated: initialState.isAuthenticated,
      setAuth: (token, user) =>
        set({
          token,
          user,
          isAuthenticated: true,
        }),
      clearAuth: () =>
        set({
          token: null,
          user: null,
          isAuthenticated: false,
        }),
      setUser: (user) => set({ user }),
    }),
    {
      name: 'admin-auth-storage',
      partialize: (state) => ({
        token: state.token,
        user: state.user,
        isAuthenticated: state.isAuthenticated,
      }),
    }
  )
);
